import {useEffect,useState } from 'react'
import { getOneSuscription,getOneSuscriptionGral } from '../requests/request';
import { useAppSelector  } from "../../../../../../redux/hooks"
import { useAuth } from '../../../../auth';

export default function GetOrdenCompra (props:any) {
    const Id = useAppSelector(state => state.SuscriptionSlice.id)
    const tenant= useAppSelector(state =>state.TenantSlice.id)

    const{currentUser}= useAuth()


    const [prueba,setprueba]= useState({
      
        id: 0,
        purchaseOrden: "",
        startDate: "",
        endDate: "",
        metadata: {
            datatransferavailable: 0
    
        },
    
        tenantId: 0,
    
        ownerFullName: "",
    
        ownerEmail: "",

    }
    )
    
  useEffect( () => {

      if(Id !== 0  && tenant===0 && currentUser?.ListPermiso?.includes('Accounts.Billing')){
        getOneSuscription(Id).then(response=>{
            setprueba(response.data)
        })

      }
      else if(Id !== 0  && tenant!==0 && currentUser?.ListPermiso?.includes('Accounts.Billing')){
        getOneSuscriptionGral(Id,tenant).then(response=>{
            setprueba(response.data)
        })

      }

 }, [Id]
 )


    if (Id !== 0 ){

    return(
        <div style={{ marginLeft: '15px'}} className="card card-custom flex-column-fluid">
                <div className="card-header bg-marino  flex-center">
                    <h4 className=" f-titulo-cards fs-p f-titulo text-w ">CUSTOMER</h4>
                </div>
                <div className="card-body  ">
                

                <table className="w-full f-parrafo  caption-bottom  custom-table">
                  <thead className='flex-center'>
                      <tr className="fw-bolder fs-6 text-marino ">
                          <th>SERVICE OWNER</th>
                          <th>CONTACT</th>
                      </tr>
                  </thead>
                  <tbody className='flex-center'>
                      <tr>
                          {prueba.ownerFullName!==null&& prueba.ownerFullName!==undefined&&<td> { prueba.ownerFullName}</td>}
                          <td> {prueba.ownerEmail}</td>
                      </tr>
                      <tr></tr>
                  </tbody>
                </table>

                <table className="w-full f-parrafo  caption-bottom  custom-table">
                  <thead className='flex-center'>
                      <tr className="fw-bolder fs-6 text-gray-800  ">
                          <th>SERVICE PERIOD</th>
                          <th></th>
                      </tr>
                  </thead>
                  <tbody className='flex-center'>
                      <tr>
                          <td>Desde: </td>
                          <td>{prueba.startDate}</td>
                      </tr>
                      <tr>
                          <td>Hasta:</td>
                          <td>{prueba.endDate}</td>
                      </tr>
                  </tbody>
                </table>

                
                  
                
                </div>
      </div>
    )
  
}

else{

return(
        <div style={{ marginLeft: '15px'}} className="card card-custom flex-column-fluid">
                <div className="card-header bg-marino  flex-center">
                    <h4 className="f-titulo-cards fs-p  text-w">CLIENT</h4>
                </div>
                <div className="card-body  ">
                

                <table className="table table-row-dashed table-row-gray-300 gy-2">
                 
                  <tbody className='flex-center'>
                     <div className="text-center f-parrafo ">
                         Select a Cloud with available subscriptions
                    </div>
                  </tbody>
                </table>

                </div>
      </div>
    )
}}